<template>
	<v-app>
		<Notification />
		<router-view />
		<BulkDialog />
		<DeleteDialog />
		<RefetchStatsDialog />
	</v-app>
</template>

<script>
import Notification from '@/components/Notification';

export default {
	components: {
		Notification,
		BulkDialog: () => import('@/components/Global/Article/BulkDialog'),
		DeleteDialog: () => import('@/components/Global/Article/DeleteDialog'),
		RefetchStatsDialog: () => import('@/components/Global/Article/RefetchStatsDialog'),
	},
};
</script>

<style lang="scss">
html {
	scroll-behavior: smooth;
}
.v-autocomplete
.v-input__icon.v-input__icon--append
i {
	cursor: pointer;
}
.v-chip__close > .v-icon {
	cursor: pointer;
}
.v-menu__content.v-autocomplete__content.menuable__content__active {
	z-index: 210 !important;
}
.v-menu__content.menuable__content__active {
	z-index: 210 !important;
}
// Image won't fill div sometimes Issue #406
.v-image__image {
	width: 100.3%;
}
</style>
